export { ReportModel } from './Report.model';
export { ResisterDetailModel } from './ResisterDetail.model';
export { ResisterModel } from './Resister.model';
